/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createListApiAccessResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type ListApiAccessResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organization/api-access/list
 */
export interface ListRequestBuilder extends BaseRequestBuilder<ListRequestBuilder> {
    /**
     * Retrieve a list of API Access entries for the specified organization (max 5)
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ListApiAccessResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 401 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ListApiAccessResponse | undefined>;
    /**
     * Retrieve a list of API Access entries for the specified organization (max 5)
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ListRequestBuilderUriTemplate = "{+baseurl}/api/organization/api-access/list";
/**
 * Metadata for all the requests in the request builder.
 */
export const ListRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ListRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createListApiAccessResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
